import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './report.css';
import ApiService from '../../../services/apiService';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ReportTotalOrder = ({ Currency }) => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedFilter, setSelectedFilter] = useState('1');
  const ThirdFilter = [
    { value: '0', label: 'Yesterday' },
    { value: '1', label: 'Today' },
    { value: '2', label: 'Week' },
    { value: '3', label: 'Month' },
  ];
  const handleFilterChange = async (selectedFilter) => {
    setSelectedFilter(selectedFilter?.value);
  };
  const getFormattedDate = (date) => {
    return new Date(date).toISOString().slice(0, 16); // Returns format "YYYY-MM-DDTHH:mm"
  };
  const today = new Date();

  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  const totalAmount = data?.reduce((sum, row) => sum + (parseFloat(row?.TotalRevenue) || 0), 0);
  const totaltax = data?.reduce((sum, row) => sum + (parseFloat(row?.TaxAmount) || 0), 0);
  const subTotal = data?.reduce((sum, row) => sum + (parseFloat(row?.TotalSubTotal) || 0), 0);

  const getReportData = async (newPageNo = pagination?.currentPage) => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      // params.append('StartDate', formData?.fromDate);
      // params.append('EndDate', formData?.toDate);
      params.append('GetBy', selectedFilter);
      const res = await apiService.getApiParamater('GET_ORDER_SALE', `?${params.toString()}`);
      setData(res?.data?.result || []);
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-lg-5">
      <button className="btn addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <div className="row">
        <div className="col-3">
          <label htmlFor="validationCustom01" className="form-label w-50">
            {t('from')} {t('date')}
          </label>
          <input type="datetime-local" className="form-control" value={formData?.fromDate} onChange={handleInputChange} name="fromDate" />
        </div>
        <div className="col-3">
          <label htmlFor="validationCustom01" className="form-label w-50">
            {t('to')} {t('date')}
          </label>
          <input type="datetime-local" className="form-control" value={formData?.toDate} onChange={handleInputChange} name="toDate" />
        </div>
        <div className="col-2 mt-3">
          <button className=" mt-3 addItem-btn" type="submit" onClick={getReportData}>
            {t('search')}
          </button>
        </div>
        <div className="col mt-4">
          <nav className="nav nav-pills weekfilter ">
            {ThirdFilter?.map((filter) => (
              <button
                key={filter?.value}
                className={`nav-link p-3 ${selectedFilter === filter.value ? 'activecls' : ''}`}
                onClick={() => handleFilterChange(filter)}
              >
                {filter?.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div className="POsgridshad rounded p-4 mt-5">
        <div className="custom-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Order Id</th>
                <th>Payment Date</th>
                <th>Payment Type</th>
                <th>Amount</th>
                <th>Order Status</th>
                <th>{t('tax')}</th>
                <th>{t('total')}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr>
                  <td>{item?.ItemName || '---'}</td>
                  <td>{item?.CategoryName || '---'}</td>
                  <td>{item?.Variant || '---'}</td>
                  <td>{item?.TotalQuantity || '---'}</td>
                  <td>{item?.TotalSubTotal?.toFixed(2) || '---'}</td>
                  <td>{item?.TaxAmount?.toFixed(2) || '---'}</td>
                  <td>{item?.TotalRevenue?.toFixed(2) || '---'}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-green-100 font-bold">
                <td colSpan={6} className="text-end">
                  {t('subtotal')}
                </td>
                <td>{subTotal?.toFixed(2) || '---'}</td>
              </tr>
              <tr className="bg-green-100 font-bold">
                <td colSpan={6} className="text-end">
                  {t('total')} {t('tax')}
                </td>
                <td>{totaltax?.toFixed(2) || '---'}</td>
              </tr>
              <tr className="bg-green-100 font-bold">
                <td colSpan={6} className="text-end">
                  {t('total')}
                </td>
                <td>{totalAmount?.toFixed(2) || '---'}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(ReportTotalOrder);
